export default __webpack_public_path__ + "static/media/warning-2.ea4e6d45.svg";